import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const bonos = [{
  num: 1,
  title: 'PROTOCOLO TÉ DORADO',
  desc: '14 días para nivelar tu glucosa en ayunas sin medicación extra.',
  icon: '🍵',
  value: '8.999'
}, {
  num: 2,
  title: 'LISTA NEGRA DE MEDICAMENTOS',
  desc: 'Lo que eleva tu glucosa en secreto y la mayoría toma sin saber.',
  icon: '💊',
  value: '7.999'
}, {
  num: 3,
  title: 'GUÍA DE SUSTITUCIONES INTELIGENTES',
  desc: 'Convertí cualquier receta común en una apta para vos.',
  icon: '🔄',
  value: '6.999'
}, {
  num: 4,
  title: 'PLANIFICADOR DE MENÚ 30 DÍAS',
  desc: 'Qué comer cada día para no improvisar ni arriesgarte.',
  icon: '📅',
  value: '4.999'
}, {
  num: 5,
  title: 'CALCULADORA DE PORCIONES Y CARBOS',
  desc: 'Comé sin miedo sabiendo cuánto podés sin arriesgar.',
  icon: '📊',
  value: '5.999'
}, {
  num: 6,
  title: 'MANUAL DE HARINAS FUNCIONALES',
  desc: 'Mezclas caseras económicas para tu pre-mezcla sin glúten.',
  icon: '🏪',
  value: '9.999'
}];
export function BonosSection() {
  return <section className="py-20 px-4 bg-brand-ink border-t border-brand-gold/15 relative overflow-hidden mt-[-100px] mb-[-100px]" data-id="element-16">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-17"></div>

      <div className="max-w-5xl mx-auto relative z-10 border border-brand-gold/30 rounded-3xl p-6 sm:p-12 bg-brand-base/40 backdrop-blur-sm" style={{
      boxShadow: '0 30px 80px -20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(212, 168, 67, 0.1)'
    }} data-id="element-18">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-base px-6 py-2 rounded-full font-extrabold shadow-lg flex items-center gap-2 glow-gold" data-id="element-19">
          <span data-id="element-20">🎁</span> 6 BONOS ESTRATÉGICOS
        </div>

        <div className="mb-10 mt-6 text-center" data-id="element-21">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-brand-gold mb-3 glow-gold tracking-wide" data-id="element-22">
            ✦ SIEMPRE INCLUIDOS — SIN COSTO ✦
          </h2>
          <p className="text-brand-cream/75 text-sm sm:text-base" data-id="element-23">
            Cada bono suma valor real a tu Megapack. Hoy todos GRATIS.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 mb-10" data-id="element-24">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-brand-base/70 p-5 rounded-2xl border border-brand-gold/25 flex flex-col items-start text-left h-full" data-id="element-25">
              <div className="flex items-center gap-2 mb-3" data-id="element-26">
                <span className="text-2xl" data-id="element-27">{bono.icon}</span>
                <span className="bg-brand-gold/15 text-brand-gold text-[10px] font-extrabold px-2.5 py-1 rounded-md tracking-widest border border-brand-gold/30" data-id="element-28">
                  BONO 0{bono.num}
                </span>
              </div>
              <h3 className="text-sm sm:text-base font-extrabold text-brand-gold mb-2 leading-tight glow-gold" data-id="element-29">
                {bono.title}
              </h3>
              <p className="text-brand-cream/75 text-sm mb-4 flex-grow leading-snug" data-id="element-30">
                {bono.desc}
              </p>

              <div className="flex justify-between items-center mt-auto w-full pt-3 border-t border-brand-gold/15" data-id="element-31">
                <span className="text-sm text-brand-cream/40 line-through" data-id="element-32">
                  ${bono.value}
                </span>
                <span className="text-base font-extrabold text-brand-gold glow-gold tracking-wide" data-id="element-33">
                  ✦ GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-6 border border-brand-gold/40" style={{
        background: 'linear-gradient(135deg, rgba(212,168,67,0.10), rgba(212,168,67,0.04))'
      }} data-id="element-34">
          <div className="text-center sm:text-left" data-id="element-35">
            <p className="text-brand-cream/70 font-medium mb-1 text-xs uppercase tracking-[0.18em]" data-id="element-36">
              💰 Valor total de los bonos
            </p>
            <p className="text-3xl sm:text-4xl font-extrabold line-through text-brand-cream/40" data-id="element-37">
              $44.994 ARS
            </p>
          </div>
          <div className="w-px h-16 bg-brand-gold/30 hidden sm:block" data-id="element-38"></div>
          <div className="text-center sm:text-right" data-id="element-39">
            <p className="text-brand-cream/70 font-medium mb-1 text-xs uppercase tracking-[0.18em]" data-id="element-40">
              Con tu Megapack
            </p>
            <p className="text-4xl sm:text-5xl font-extrabold flex items-center gap-3 justify-center sm:justify-end text-brand-gold glow-gold" data-id="element-41">
              <span className="bg-brand-gold text-brand-base rounded-full p-1" data-id="element-42">
                <Check size={22} strokeWidth={4} data-id="element-43" />
              </span>
              ✦ GRATIS
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}